/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";

class blueTextBox extends PolymerElement {
  static get properties() {
    return {
      label: {
        type: String,
        notify: true,
        observer: '_label'
      }
    };
  }

  static get template() {
    return html`
<style include="app-styles">
.bluecol{
background-color:var(--brand-color-50)
}
</style>
<div class="mdl-grid content-align-center bluecol">
<div id="detailsBlock" class="mdl-cell--12-col full-width font-size-s layout-col-1 horizontal layout " phone$="{{phone}}" tablet$="{{tablet}}">{{label}}
</div>
</div>
    `;
  }

  constructor() {
    super();
  }

  _label() {
    this.label = getLabel(this.label);
  }

  _validate() {
    var isValid = true; // this.setValidity(true, undefined);

    if (_.isUndefined(this.value) || _.isEmpty(this.value)) {
      this.$.newPin.invalid = true;
      this.$.newPin.errorMessage = getLabel(this.errorMessage); // this.setValidity(false, 'wrongValue');

      isValid = false;
    }

    return isValid;
  }

}

customElements.define('blue-text-box', blueTextBox);